import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Referrer from './Referrer';
import Privacy from './Privacy';
import Terms from './Terms';
import Support from './Support';
import Contact from './Contact';
import DiscordReferrer from './DiscordReferrer';
import Arbitrage from './Arbitrage';
import Unsubscribe from './Unsubscribe';
import UnsubscribeSuccess from './UnsubscribeSuccess';
import ResetPassword from './ResetPassword';
import AppRedirect from './AppRedirect';
import DownloadRedirect from './DownloadRedirect';
import Affiliates, { AffiliateProgramTerms } from './Affiliates';
import FeatureRequestsPage from './featureRequests/FeatureRequestsPage';
import Psa10Returns from './Psa10Returns';
import { getPathReferralCode } from './referralRouting';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const path = window.location.pathname.replace(/\/+$/, '');
const searchParams = new URLSearchParams(window.location.search);
const isReferrerPage = path === '/referrer';
const isHomeReferralPage = path === '' && Boolean(searchParams.get('ref'));
const isShortCodeReferralPage = Boolean(getPathReferralCode(window.location.pathname));
const isPrivacyPage = path === '/privacy';
const isTermsPage = path === '/terms' || path === '/terms-of-use';
const isSupportPage = path === '/support';
const isContactPage = path === '/contact';
const isDiscordReferrerPage = path === '/discord-referrer';
const isArbitragePage = path === '/grading-plays';
const isUnsubscribeSuccessPage = path === '/unsubscribe/success';
const isUnsubscribePage = path === '/unsubscribe';
const isResetPasswordPage = path === '/reset-password';
const isAppRedirectPage = path === '/app';
const isDownloadRedirectPage = path === '/download';
const isAffiliatesPage = path === '/affiliates';
const isAffiliateProgramTermsPage = path === '/affiliate-program-terms';
const isFeatureRequestsPage = path === '/feature-requests' || path === '/features';
const isPsa10ReturnsPage = path === '/psa-10-returns';

root.render(
  <React.StrictMode>
    {isPsa10ReturnsPage ? <Psa10Returns /> :
     isFeatureRequestsPage ? <FeatureRequestsPage /> :
     isArbitragePage ? <Arbitrage /> :
     (isReferrerPage || isHomeReferralPage || isShortCodeReferralPage) ? <Referrer /> :
     isPrivacyPage ? <Privacy /> :
     isTermsPage ? <Terms /> :
     isSupportPage ? <Support /> :
     isContactPage ? <Contact /> :
     isDiscordReferrerPage ? <DiscordReferrer /> :
     isUnsubscribeSuccessPage ? <UnsubscribeSuccess /> :
     isUnsubscribePage ? <Unsubscribe /> :
     isResetPasswordPage ? <ResetPassword /> :
     isAppRedirectPage ? <AppRedirect /> :
     isDownloadRedirectPage ? <DownloadRedirect /> :
     isAffiliateProgramTermsPage ? <AffiliateProgramTerms /> :
     isAffiliatesPage ? <Affiliates /> :
     <App />}
  </React.StrictMode>
);
